import loadingIcon from '@img/icon_loading_2.png'

// 创建 loading 元素
function createLoadingElement() {
  const loadingElement = document.createElement('div')
  loadingElement.className = 'v-loading-mask'

  const loadingSpinner = document.createElement('div')
  loadingSpinner.className = 'v-loading-spinner'

  const loadingImg = document.createElement('div')
  // loadingImg.src = loadingIcon
  loadingImg.className = 'v-loading-image'
  loadingImg.style.backgroundImage = `url(${loadingIcon})`

  loadingSpinner.appendChild(loadingImg)
  loadingElement.appendChild(loadingSpinner)

  return loadingElement
}

// 添加样式
function addStyles() {
  const styleId = 'v-loading-styles'
  if (document.getElementById(styleId)) {
    return
  }

  const style = document.createElement('style')
  style.id = styleId
  style.textContent = `
    .v-loading-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999;
    }
    
    .v-loading-spinner {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.6rem;
      height: 1.6rem;
      box-sizing: border-box;
      display: block;
      padding: .33333rem;
      background-color: #343a3f;
      border-radius: 18px;
    }
    
    .v-loading-image {
      width: 100%;
      height: 100%;
      animation: loading-rotate 2s linear infinite;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
    }
    @keyframes loading-rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .v-loading-relative {
      position: relative !important;
    }
  `
  document.head.appendChild(style)
}

// loading 指令
const loading = {
  bind(el, binding) {
    // 添加样式
    addStyles()

    // 保存原始 position 值
    const originalPosition = window.getComputedStyle(el).position
    el._originalPosition = originalPosition

    if (binding.value) {
      // 如果元素的 position 不是 relative, absolute 或 fixed，则设置为 relative
      if (!['relative', 'absolute', 'fixed'].includes(originalPosition)) {
        el.classList.add('v-loading-relative')
      }

      // 创建并添加 loading 元素
      const loadingElement = createLoadingElement()
      el._loadingElement = loadingElement
      el.appendChild(loadingElement)
    }
  },

  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        // 显示 loading
        if (!['relative', 'absolute', 'fixed'].includes(el._originalPosition)) {
          el.classList.add('v-loading-relative')
        }

        if (!el._loadingElement) {
          const loadingElement = createLoadingElement()
          el._loadingElement = loadingElement
          el.appendChild(loadingElement)
        }
      } else {
        // 隐藏 loading
        if (el._loadingElement) {
          el.removeChild(el._loadingElement)
          el._loadingElement = null
        }

        // 恢复原始样式
        if (!['relative', 'absolute', 'fixed'].includes(el._originalPosition)) {
          el.classList.remove('v-loading-relative')
        }
      }
    }
  },

  unbind(el) {
    // 清理
    if (el._loadingElement) {
      el.removeChild(el._loadingElement)
      el._loadingElement = null
    }

    // 恢复原始样式
    if (!['relative', 'absolute', 'fixed'].includes(el._originalPosition)) {
      el.classList.remove('v-loading-relative')
    }
  },
}

export default loading
